export default function CsharpBooleans() {
  return (
    <h2>Csharp Booleans</h2>
  );
}
